import React, { useState } from 'react'
import { ButtonWithLoadingState } from "../Buttons";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from 'react-i18next'

const InventoryAssetReorderModal = ({ handleClose, askForReorder, askForReturn, setReorder, setReturn }) => {
    const { t } = useTranslation()
    const [autoReorder, setAutoReorder] = useState(false)
    const [autoReturn, setAutoReturn] = useState(false)
    const handleSubmit = (yes) => {
        if (askForReorder && !askForReturn) {
            setReorder(yes)
        } else if (askForReturn && !askForReorder) {
            setReturn(yes)
        }
        handleClose(true)
    }
    return (
        <div>
            {/* enforceFocus for OverlayRight with overLayZIndex with inputs  */}
            <Modal show={true} size="lg" onHide={handleClose} enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{askForReorder ? t('inventory:assetReorderAmountsTitle') : t('inventory:assetReturnAmountsTitle')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {askForReorder && askForReturn ? (
                            <>
                                <Form.Check
                                    type='checkbox'
                                    id='automaticReorder'
                                    name='automaticReorder'
                                    label={t('inventory:assetReorderAmountsCheckbox')}
                                    checked={autoReorder}
                                    onChange={(e) => {
                                        setReorder(e.target.checked)
                                        setAutoReorder(e.target.checked)
                                    }
                                    }
                                />
                                <Form.Check
                                    type='checkbox'
                                    id='automaticReturn'
                                    name='automaticReturn'
                                    label={t('inventory:assetReturnAmountsCheckbox')}
                                    checked={autoReturn}
                                    onChange={(e) => {
                                        setReturn(e.target.checked)
                                        setAutoReturn(e.target.checked)
                                    }
                                    }
                                />
                            </>
                        ) : (
                            <>{askForReorder ? t('inventory:assetReorderAmountsBody') : t('inventory:assetReturnAmountsBody')}<br /><br /></>
                        )}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleClose(false)}>{t('cancelButton')}</Button>
                    {!(askForReorder && askForReturn) && <Button variant="secondary" onClick={() => handleSubmit(false)}>{t('no')}</Button>}
                    <ButtonWithLoadingState
                        onClick={() => handleSubmit(true)}
                        buttonText={!(askForReorder && askForReturn) ? t('yes') : t('inventory:confirm')}
                    />
                </Modal.Footer>
            </Modal>
        </div>
    )
}
export default InventoryAssetReorderModal